import {
  ColorPickerInput,
  Content,
  Page,
  required,
  Textarea,
  TruForm,
  TruFormButton,
  urlRule,
  useForm,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { useEffect, useState } from 'react';

import './style.scss';
import { useHistory } from 'react-router';
import {
  useGetCompany,
  useUpdateCompany,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
type IForm = {
  logo: string;
  applicationIcon: string;
  primary: string;
  secondary: string;
  tertiary: string;
};
export const Branding = () => {
  const history = useHistory();
  const toaster = useToastContext();
  const [loading, setLoading] = useState<boolean>(false);
  const backupColor = '#000000';
  const updateCompany = useUpdateCompany();
  const { data: company } = useGetCompany();

  const Form = useForm<IForm>({
    logo: '',
    applicationIcon: '',
    //@ts-ignore  until branding add to truDomain
    primary: company?.branding?.colors?.primary ?? backupColor,
    //@ts-ignore  until branding add to truDomain
    secondary: company?.branding?.colors?.secondary ?? backupColor,
    //@ts-ignore  until branding add to truDomain
    tertiary: company?.branding?.colors?.tertiary ?? backupColor,
  });

  useEffect(() => {
    Form.update({
      //@ts-ignore  until branding add to truDomain
      logo: company?.branding?.logo,
      //@ts-ignore  until branding add to truDomain
      applicationIcon: company?.branding?.applicationIcon,
      //@ts-ignore  until branding add to truDomain
      primary: company?.branding?.colors?.primary ?? backupColor,
      //@ts-ignore  until branding add to truDomain
      secondary: company?.branding?.colors?.secondary ?? backupColor,
      //@ts-ignore  until branding add to truDomain
      tertiary: company?.branding?.colors?.tertiary ?? backupColor,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  const onFinish = async (values: Partial<IForm>) => {
    try {
      setLoading(true);
      const branding = {
        logo: values.logo,
        applicationIcon: values.applicationIcon,
        colors: {
          primary: values.primary,
          secondary: values.secondary,
          tertiary: values.tertiary,
        },
      };
      //@ts-ignore  until branding add to truDomain
      await updateCompany({ branding });
      toaster.success('Branding has updated successfully!');
      setLoading(false);
    } catch (message) {
      setLoading(false);
      toaster.error('Unexpected error: Branding update failed!');
    }
  };
  return (
    <Content>
      <Page className="branding-container">
        <p className="branding-container__title">Branding</p>

        <TruForm onFinish={onFinish} form={Form}>
          <div className="branding-container__logo-block">
            <p className="branding-container__logo-block__title">Logo</p>
            <div className="branding-container__logo-block__uploader">
              <Form.Item
                rules={[required, ...urlRule]}
                name="logo"
                label="Logo"
              >
                <Textarea />
              </Form.Item>
            </div>
            <div className="branding-container__logo-block__uploader">
              <Form.Item
                label="Application Icon"
                name="applicationIcon"
                rules={[required, ...urlRule]}
              >
                <Textarea />
              </Form.Item>
            </div>
          </div>
          <div className="branding-container__color-block">
            <p className="branding-container__color-block__title">
              Brand Color
            </p>
            <div className="branding-container__color-block__container">
              <div className="color-input">
                <Form.Item rules={[required]} name="primary" label="Primary">
                  <ColorPickerInput />
                </Form.Item>
                <p className="helping-text">
                  This is the main shade of the brand, and will affect the
                  primary buttons and links.
                </p>
              </div>
              <div className="color-input">
                <Form.Item
                  name="secondary"
                  label="Secondary"
                  rules={[required]}
                >
                  <ColorPickerInput />
                </Form.Item>
                <p className="helping-text">
                  This shade will be used for headers, which need to be darker
                  than the primary color.
                </p>
              </div>
              <div className="color-input">
                <Form.Item name="tertiary" rules={[required]} label="Tertiary">
                  <ColorPickerInput />
                </Form.Item>
                <p className="helping-text">
                  This shade will be used for backgrounds, so it must be the
                  lightest shade.
                </p>
              </div>
            </div>
          </div>
          <Form.Item shouldUpdate>
            {() => (
              <div className="branding-container__actions-block">
                <TruFormButton
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={!Form.valid()}
                >
                  Save
                </TruFormButton>
                <TruFormButton
                  onClick={() =>
                    history.push('/configurations/company-details/')
                  }
                  type="secondary"
                  htmlType="button"
                >
                  Cancel
                </TruFormButton>
              </div>
            )}
          </Form.Item>
        </TruForm>
      </Page>
    </Content>
  );
};
